<template>
    <router-view />
    <AppHeader />
    <ProfileBox v-if="$route.path !== '/signup'" :profile="this.profile" />
</template>

<script>
import ProfileBox from "./components/ProfileBox.vue"
import AppHeader from "./AppHeader.vue"
import EventBus from "./eventBus.js"
import axios from "axios"
import { useToast } from "vue-toastification"

const DEFAULT_PROFILE = () => ({
    id: -1,
    name: ""
});

const PROFILE_STORAGE_KEY = "profile";
const TOKEN_STORAGE_KEY = "token";

export default {
    name: 'App',
    components: { ProfileBox, AppHeader },
    data() {
        return {
            profile: DEFAULT_PROFILE()
        } 
    },
    async created() {
        const toast = useToast();
        axios.interceptors.response.use(
            response => response,
            error => {
                if (error.response?.status === 429) {
                    toast.error("Too many requests!");
                }
                return Promise.reject(error);
            }
        );

        EventBus.on("login-profile", ({profile, auth_token}) => {
            EventBus.emit("update-profile", { profile, auth_token });
        });

        EventBus.on("update-profile", ({profile, auth_token}) => {
            if (profile) {
                this.profile = profile;
                localStorage.setItem(PROFILE_STORAGE_KEY, JSON.stringify(this.profile));
            }
            if (auth_token) {
                localStorage.setItem(TOKEN_STORAGE_KEY, auth_token);
                axios.defaults.headers.common["Authorization"] = auth_token;
            }
        })

        EventBus.on("logout-profile", () => {
            this.profile = DEFAULT_PROFILE();
            axios.defaults.headers.common["Authorization"] = "";
            localStorage.clear();
            EventBus.emit("load-view");
        });

        const token = localStorage.getItem(TOKEN_STORAGE_KEY);
        if (token) {
            const data = token.split(".")[1];
            const profile_data = atob(data);
            const profile = JSON.parse(profile_data);
            if (profile.exp * 1000 < Date.now()) {
                EventBus.emit("logout-profile");
                return;
            }

            axios.defaults.headers.common["Authorization"] = token;

            try {
                const response = await axios.get("/load-profile");
                if (response.status == 200) {
                    EventBus.emit("update-profile", {
                        profile: response.data.profile,
                        auth_token: response.data.authorization.token
                    });
                    return;
                }
            } catch (err) {
                console.error(err);
            }
        }

        axios.defaults.headers.common["Authorization"] = null;

        localStorage.removeItem(PROFILE_STORAGE_KEY);
        localStorage.removeItem(TOKEN_STORAGE_KEY);
    }
}
</script>

<style>
    body {
        background-color: #636363;
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #14171b
    }
</style>
